import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "section__container"
}
const _hoisted_2 = { class: "section__content d-flex justify-content-end mb-4" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", null, [
    (_ctx.disclaimer !== _ctx.DISCLAIMER.DISAGREED && _ctx.disclaimer !== _ctx.DISCLAIMER.NOACCESS && _ctx.hasRedirectUrl)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _renderSlot(_ctx.$slots, "buttons", { confirm: _ctx.confirm })
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}